/**
 * Ключ заголовка для SEO
 */
export const X_SEO_HEADER_KEY = 'x-seo' as const;

/**
 * Значения заголовка SEO для разных типов страниц
 */
export const X_SEO_HEADER_VALUES = {list: 'list', detail: 'detail', all: 'all'} as const;

/**
 * Интерфейс для параметров создания заголовков
 */
export interface IHeadersBuilderOptions {
    /** Включить SEO заголовки и выбрать тип */
    withSeo?: keyof typeof X_SEO_HEADER_VALUES;
    /** Дополнительные заголовки */
    additionalHeaders?: Record<string, string> | null;
}

/**
 * Создает заголовки для API запросов с опциональной SEO поддержкой
 * @param options - Параметры конфигурации для заголовков
 * @returns Объект заголовков для запроса
 */
export const buildHeaders = (options: IHeadersBuilderOptions = {}): Record<string, string> => {
    const {withSeo, additionalHeaders = {}} = options;
    const baseHeaders = additionalHeaders || {};

    if (withSeo) {
        return {[X_SEO_HEADER_KEY]: X_SEO_HEADER_VALUES[withSeo], ...baseHeaders};
    }

    return baseHeaders;
};

/**
 * Создает заголовки с поддержкой cookies для серверных запросов
 * @param options - Параметры конфигурации для заголовков
 * @param cookieHeader - Заголовок cookies из getRequestCookieHeader()
 * @returns Объект заголовков с cookies
 */
export const buildHeadersWithCookies = (
    options: IHeadersBuilderOptions = {},
    cookieHeader?: Record<string, string> | null,
): Record<string, string> => {
    const mergedHeaders = {...(cookieHeader || {}), ...(options.additionalHeaders || {})};
    return buildHeaders({...options, additionalHeaders: mergedHeaders});
};
